import CheckToggle from './CheckToggle.component';

export default CheckToggle;
